import { render } from "./PrimaryNav.vue?vue&type=template&id=22b1f739&scoped=true&ts=true"
import script from "./PrimaryNav.vue?vue&type=script&lang=ts"
export * from "./PrimaryNav.vue?vue&type=script&lang=ts"

import "./PrimaryNav.vue?vue&type=style&index=0&id=22b1f739&lang=postcss&scoped=true"

import exportComponent from "/builds/wVusKqw4/1/kenniss/platform/educator/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22b1f739"]])

export default __exports__